import React, { useEffect, useState } from 'react'
import times from 'lodash/times'
import { Box, Grid, Skeleton } from 'transfix-ui/core'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useBookableShipmentRecommendations } from 'apps/fleet-planner/types'
import { BookableShipmentSavedSearchAlertPlaceholder } from './BookableShipmentSavedSearchAlertPlaceholder'
import { BookableShipmentSearchRunItAgainBookContainerRow } from './BookableShipmentSearchRunItAgainBookContainerRow'

const PAGE_NUMBER = 1
const PAGE_SIZE = 10
const LOAD_RECOMMENDATIONS_LIMIT = 3

export const BookableShipmentSavedSearchRunItAgainSection = () => {
  const { isMobile } = useBreakpointContext()
  const {
    data,
    loading: isLoading,
    refetch: refetchBookableShipmentSearch,
  } = useBookableShipmentRecommendations({
    lazy: true,
  })

  const [hasSearched, setHasSearched] = useState<boolean>(false)
  const { bookableShipmentSavedSearchRecommendations = [] } = data || {}
  const firstThreeSavedSearchRecommendations = bookableShipmentSavedSearchRecommendations.slice(
    0,
    3
  )

  // Fetch bookable shipments on page load
  useEffect(() => {
    refetchBookableShipmentSearch({
      queryParams: {
        sourceTypes: ['auto_historical'],
        limit: LOAD_RECOMMENDATIONS_LIMIT,
        pageNumber: PAGE_NUMBER,
        pageSize: PAGE_SIZE,
      },
    })
    // hasSearched to determine when to display empty state.
    if (hasSearched === false) {
      setHasSearched(true)
    }
  }, [])

  return (
    <div>
      {/* Loading state */}
      {isLoading &&
        times(3).map(item => (
          <Box key={item} pl={1} pt={4}>
            <Grid container>
              {times(4).map(item => (
                <Grid key={item} item md={3} xs={12}>
                  <Skeleton
                    variant='rectangular'
                    height={isMobile ? '80px' : '240px'}
                    width={isMobile ? '100%' : '95%'}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}

      {/* Empty State */}
      {!isLoading && hasSearched && bookableShipmentSavedSearchRecommendations?.length === 0 && (
        <BookableShipmentSavedSearchAlertPlaceholder
          iconVariant='runItAgain'
          message='Recommendations based on loads you’ve run'
          subMessage='Loads will show up after you’ve run loads with Transfix'
        />
      )}

      {/*  Recommendations */}
      {!isLoading &&
        firstThreeSavedSearchRecommendations?.length > 0 &&
        firstThreeSavedSearchRecommendations.map(loadRecommendation => {
          const { id: savedSearchId } = loadRecommendation || {}
          return (
            <Box key={savedSearchId}>
              <BookableShipmentSearchRunItAgainBookContainerRow
                loadRecommendation={loadRecommendation}
              />
            </Box>
          )
        })}
    </div>
  )
}
